import { backofficeRequest } from '../../../axios'

export const getTickets = async (search = null) => {
  try {
    const { data } = await backofficeRequest.get(
      'zendesk/search/internal-tickets',
      {
        params: {
          query: search,
        },
      }
    )
    return data
  } catch (error) {
    return error
  }
}

export const getAssociatedTickets = async (zendeskTicketId) => {
  try {
    const { data: tickets } = await backofficeRequest.get(
      `zendesk/${zendeskTicketId}/tickets`
    )
    const { data: draftTickets } = await backofficeRequest.get(
      `zendesk/${zendeskTicketId}/tickets-drafts`
    )

    const allTickets = [...tickets, ...draftTickets].sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )

    return allTickets
  } catch (error) {
    return error
  }
}

export const linkInternalTicketsToZendeskTicket = async (
  zendeskTicketId,
  data
) => {
  const { tickets, zendeskTicket } = data

  const draftTicketIds = tickets
    .filter((ticket) => ticket.isDraftTicket)
    .map((ticket) => ticket.id)

  const ticketIds = tickets
    .filter((ticket) => !ticket.isDraftTicket)
    .map((ticket) => ticket.id)

  try {
    if (draftTicketIds.length > 0) {
      await backofficeRequest.post(
        `zendesk/${zendeskTicketId}/tickets-drafts`,
        { ticketIds: draftTicketIds, zendeskTicket }
      )
    }
    if (ticketIds.length > 0) {
      await backofficeRequest.post(`zendesk/${zendeskTicketId}/tickets`, {
        ticketIds,
        zendeskTicket,
      })
    }
  } catch (error) {
    return error
  }
}

export const unlinkInternalTicketFromZendeskTicket = async ({
  internalTicketId,
  zendeskTicketId,
  isDraftTicket = false,
}) => {
  try {
    if (isDraftTicket) {
      await backofficeRequest.delete(
        `zendesk/${zendeskTicketId}/tickets-drafts/${internalTicketId}`
      )
    } else {
      await backofficeRequest.delete(
        `zendesk/${zendeskTicketId}/tickets/${internalTicketId}`
      )
    }
  } catch (error) {
    return error
  }
}
